import { reducers as reducersIsotope } from 'isotope-client'
import { session } from '../modules/common/session/sessionReducer'

export default {
	...reducersIsotope,
	session
}
